import {
  Box,
  HStack,
  KdsCallout,
  KdsCardFile,
  KdsText,
  VStack,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useState } from "react";
import { WorkflowPostponedActivityReadDtoActivityEnum } from "@/config/apiClient";
import { FeatureEnum } from "@/config/apiClient.types";
import { useGetIsFeatureActive } from "@/hooks";
import { ModalPurchaseOrderForm } from "@/modals/ModalPurchaseOrderForm";
import { type PurchaseOrderBlocProps } from "./PurchaseOrderBloc.types";

export const PurchaseOrderBloc = ({ orderItem }: PurchaseOrderBlocProps) => {
  const { t } = useTranslate();

  const [isOpenAddOrderPurchase, setIsOpenAddOrderPurchase] = useState(false);

  const { isActive: isPurchaseOrderActive } = useGetIsFeatureActive(
    FeatureEnum.PURCHASE_ORDER
  );

  const purchaseOrderFile = orderItem?.order.purchaseOrderFile;

  const hasAModificationRequest = orderItem?.Workflow.PostponedActivities.some(
    (postponedActivity) =>
      postponedActivity.activity ===
      WorkflowPostponedActivityReadDtoActivityEnum.DecideOnModificationRequest
  );

  if (!isPurchaseOrderActive) {
    return null;
  }

  return (
    <Box w="100%" rounded="br-md" bgColor="elevation.first" p="sp-md">
      <VStack gap="sp-md">
        <KdsText size="title-sm">
          {t("order.myOrdersItemDetails.orderPurchase")}
        </KdsText>

        <Box maxH="450px" overflowY="auto">
          <VStack gap="sp-md">
            {(orderItem.isPurchaseOrderAdded || purchaseOrderFile) && (
              <HStack justify="space-between" gap="sp-sm">
                <KdsText>
                  {t("orderTracking.callout.purchaseOrder.number")} :
                </KdsText>

                <KdsText size="subtitle-sm">
                  {orderItem?.order.orderNumber}
                </KdsText>
              </HStack>
            )}

            {!orderItem.isPurchaseOrderAdded && !purchaseOrderFile ? (
              <KdsCallout
                title={t("orderTracking.callout.purchaseOrder.title")}
                state="error"
                has={!hasAModificationRequest ? "button" : undefined}
                position="right"
                buttonProps={
                  !hasAModificationRequest
                    ? {
                        children: t("orderTracking.callout.purchaseOrder.cta"),
                        onPress: () => setIsOpenAddOrderPurchase(true),
                        size: "small",
                      }
                    : {}
                }
              >
                <KdsText>
                  {t("orderTracking.callout.purchaseOrder.content")}
                </KdsText>
              </KdsCallout>
            ) : (
              <KdsCardFile
                key={purchaseOrderFile?.url}
                fileName={purchaseOrderFile?.fileName}
                fileSize={purchaseOrderFile?.size}
                fileUrl={purchaseOrderFile?.url}
                isViewable
              />
            )}
          </VStack>
        </Box>
      </VStack>

      <ModalPurchaseOrderForm
        isOpen={isOpenAddOrderPurchase}
        setOpenState={setIsOpenAddOrderPurchase}
        orderId={orderItem.orderId}
      />
    </Box>
  );
};
